/**
 * Created by spepa on 10.04.2023
 */

const Achievement = function (data, completed) {
    this.type = data.type;
    this.config = data;
    this.completed = Boolean(completed);
};

Achievement.prototype.complete = function () {
    if (!this.completed) {
        this.completed = true;
        this.save();
        connector.social.markAchievement(this.config);

        cleverapps.achievements.trigger("complete", this.config);
    }
};

Achievement.prototype.isComplete = function () {
    return this.completed; 
};

Achievement.prototype.getConfig = function () {
    return this.config;
};

Achievement.prototype.save = function () {
    cleverapps.achievements.save();
};

Achievement.prototype.getIcon = function (options) {
    if (this.config.unit && cleverapps.config.type === "merge") {
        return UnitView.getUnitImage(this.config, options || {
            preferStatic: true,
            useLibraryAnchors: true
        });
    }

    return new cc.Sprite(bundles.achievements.frames[this.config.expedition || this.config.title]);
};

Achievement.prototype.getName = function () {
    if (this.config.unit && cleverapps.config.type === "merge") {
        return cleverapps.unitsLibrary.getUnitName(this.config);
    }

    if (this.config.expedition) {
        return Messages.get(`Achievements.${this.config.expedition}.title`);
    }
    return Messages.get(`Achievements.${this.config.title}.title`);
};

Achievement.prototype.getTitle = function () {
    return Messages.get(`Achievements.${this.config.title}.title`);
};

Achievement.prototype.getDescription = function () {
    if (this.config.expedition) {
        return Messages.get("Achievements.expedition.description", { location: Messages.get(`TravelBook.title.${this.config.expedition}`) });
    }
    return Messages.get(`Achievements.${this.config.title}.description`);
};